<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :filter="filter"
        module="basic"
        url="warehouseAreas"
        :columns-property="columnsProperty"
        :table-select="false"
        @reset="resetHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @addOrEdit="addEditHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="仓库名称">
              <el-input v-model.trim="filter.warehouseName" placeholder="请输入仓库名称" clearable/>
            </el-form-item>
            <el-form-item label="库区名称">
              <el-input v-model.trim="filter.warehouseAreaName" placeholder="请输入库区名称" clearable/>
            </el-form-item>
            <el-form-item label="库区编号">
              <el-input v-model.trim="filter.warehouseAreaNo" placeholder="请输入库区编号" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>

    <warehouse-area-edit ref="warehouseAreaEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import WarehouseAreaEdit from "./WarehouseAreaEdit.vue";

  export default {
    name: "WarehouseAreaList",
    components: {
      ViewTable,
      WarehouseAreaEdit,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(902),
          editAuth: this.$auth(904),
          delAuth: this.$auth(905),
        },
        filter: {
          warehouseName: "",
          warehouseAreaNo: "",
          warehouseAreaName: "",
        },
        columnsProperty: [
          {
            key: "warehouseName",
            tooltip: true,
          },
          {
            key: "warehouseAreaName",
            tooltip: true,
          },
          {
            key: "warehouseAreaNo",
            width: 120,
            align: "center",
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.warehouseAreaEdit.open(1, row);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "warehouseAreas", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.ivu-table td,
.ivu-table th {
  height: 37px;
  font-size: 13px;

  .el-button--mini {
    padding: 7px 10px;
  }
}
</style>
